"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initAPEXWebActions;
var _store = _interopRequireDefault(require("../redux/store"));
var _signupActions = require("../redux/actions/signupActions");
var _authActions = require("../redux/actions/authActions");
var _userActions = require("../redux/actions/userActions");
var _resetPasswordActions = require("../redux/actions/resetPasswordActions");
var _sidePaneActions = require("../redux/actions/sidePaneActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var APEXWebActions = /*#__PURE__*/_createClass(function APEXWebActions() {
  _classCallCheck(this, APEXWebActions);
  _defineProperty(this, "login", function (payload) {
    return _store["default"].dispatch((0, _authActions.login)(payload));
  });
  _defineProperty(this, "resetPassword", function (payload) {
    return _store["default"].dispatch((0, _resetPasswordActions.fetchResetPassword)(payload));
  });
  _defineProperty(this, "sendResetPasswordEmail", function (UserName) {
    return _store["default"].dispatch((0, _userActions.sendResetPasswordEmail)(UserName));
  });
  _defineProperty(this, "signup", function (payload) {
    return _store["default"].dispatch((0, _signupActions.signup)(payload));
  });
  _defineProperty(this, "setUserConfig", function (UserId, UserName, Config) {
    var getUserConfigAfterSetUserConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return _store["default"].dispatch((0, _userActions.setUserConfig)(UserId, UserName, Config, getUserConfigAfterSetUserConfig));
  });
  _defineProperty(this, "closeKYCSidePane", function () {
    return _store["default"].dispatch((0, _sidePaneActions.closeKYCSidePane)());
  });
  window.APEXWebActions = this;
});
function initAPEXWebActions() {
  new APEXWebActions();
}